import {
  Component,
  ElementRef,
  OnInit
} from "@angular/core";
import { shareReplay } from "rxjs/operators";
import { ChartType } from "./apex.model";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { TimezoneService } from 'src/app/services/timezone';
import { AppState } from "src/app/store/app.state";
import { ChartOptions, ChartOptions2 } from "../starter.component";
import { ApiService } from "./../../../services/api";
import {
  lineColumAreaChart
} from "./data";
@Component({
  selector: "app-net-sale",
  templateUrl: "./net-sale-new.component.html",
  styleUrls: ["./net-sale.component.scss"],
  providers: [TranslatePipe],
})
export class NetSaleComponent implements OnInit {
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<ChartOptions2>;
  selected: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    Today: [this.timezoneService.get()().startOf('day'), this.timezoneService.get()().endOf('day')],
    Yesterday: [this.timezoneService.get()().subtract(1, "days"), this.timezoneService.get()().subtract(1, "days")],
    "Last 7 Days": [this.timezoneService.get()().subtract(6, "days"), this.timezoneService.get()()],
    "Last 30 Days": [this.timezoneService.get()().subtract(29, "days"), this.timezoneService.get()()],
    "This Month": [this.timezoneService.get()().startOf("month"), this.timezoneService.get()().endOf("month")],
    "Last Month": [
      this.timezoneService.get()().subtract(1, "month").startOf("month"),
      this.timezoneService.get()().subtract(1, "month").endOf("month"),
    ],
  };
  invalidDates: moment.Moment[] = [
    this.timezoneService.get()().add(2, "days"),
    this.timezoneService.get()().add(3, "days"),
    this.timezoneService.get()().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };
  // bread crumb items
  breadCrumbItems: Array<{}>;

  linewithDataChart: ChartType;
  basicColumChart: ChartType;
  columnlabelChart: ChartType;
  lineColumAreaChart: ChartType;
  basicRadialBarChart: ChartType;
  simplePieChart: ChartType;
  donutChart: ChartType;
  barChart: ChartType;
  splineAreaChart: ChartType;
  dashedLineChart: ChartType;
  //prevStartDate: any = this.timezoneService.get()().subtract(1, "months").startOf("month");
  // prevEndDate: any = this.timezoneService.get()().subtract(1, "months").endOf("month");
  prevStartDate: any = this.timezoneService.get()().subtract(1, 'day').startOf('day');
  prevEndDate: any = this.timezoneService.get()().subtract(1, 'day').endOf('day');
  prevStartDateDisplay: any = this.prevStartDate.unix();
  prevEndDateDisplay: any = this.prevEndDate.unix();
  prevStartDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.prevStartDateDisplay)
    .format("MMM Do YY");
  prevEndDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.prevEndDateDisplay)
    .format("MMM Do YY");
  startDate: any = this.timezoneService.get()().startOf('day');
  endDate: any = this.timezoneService.get()().endOf('day');
  customEndDate: any = this.timezoneService.get()().endOf('day');
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  customEndDateDisplay: any = this.customEndDate.unix();
  startDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.startDateDisplay)
    .format("MMM D YYYY");
  endDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.endDateDisplay)
    .format("MMM D YYYY");
  currency: any = this.cookieService.get("currency");
  storeIdFixed: any = this.cookieService.get("storeId");
  merchantId: any = this.cookieService.get("merchantId");
  GLOBALURL: String;
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  textPrevious: string = "Previous";
  textCurrent: string = "Current";
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };
  cardData: any;
  constructor(
    private store: Store<AppState>,
    private cookieService: CookieService,
    private elRef: ElementRef,
    private http: HttpClient,
    private toastr: AlertService,
    private router: Router,
    private ApiService: ApiService,
    private timezoneService: TimezoneService,
    private translatePipe: TranslatePipe,
    private authService: AuthenticationService,

  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
    this.alwaysShowCalendars = true;
    (this.chartOptions = {
      series: [
        {
          name: this.textCurrent,
          data: [31, 40, 28, 51, 42, 109, 100],
          color: "#000",
        },
        {
          name: this.textPrevious,
          data: [11, 32, 45, 32, 34, 52, 41],
          color: "#CCCCCC",
        },
      ],

      chart: {
        height: 350,
        type: "line",
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      xaxis: {
        type: "datetime",
        categories: [
          "2018-09-19T00:00:00.000Z",
          "2018-09-19T01:30:00.000Z",
          "2018-09-19T02:30:00.000Z",
          "2018-09-19T03:30:00.000Z",
          "2018-09-19T04:30:00.000Z",
          "2018-09-19T05:30:00.000Z",
          "2018-09-19T06:30:00.000Z",
        ],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
    }),
      (this.chartOptions2 = {
        series: [
          {
            name: this.textCurrent,
            data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
            color: "#000",
          },
          {
            name: this.textPrevious,
            data: [20, 31, 34, 11, 79, 22, 39, 51, 148],
            color: "#888888",
          },
        ],
        chart: {
          height: 200,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 2,
        },
        // title: {
        //   text: "Gross Sales",
        //   align: "left"
        // },
        grid: {
          row: {
            colors: ["#0000", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
        },
      });
  }
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf('day'),
    endDate: this.timezoneService.get()().endOf('day'),
    // this.timezoneService.get()().startOf('month'), this.timezoneService.get()().endOf('month')
    alwaysShowCalendars: true,
    // ranges: {
    //   'Today': [this.timezoneService.get()(), this.timezoneService.get()()],
    //   'Yesterday': [this.timezoneService.get()().subtract(1, 'days'), this.timezoneService.get()().subtract(1, 'days')],
    //   'Last 7 Days': [this.timezoneService.get()().subtract(6, 'days'), this.timezoneService.get()()],
    //   'Last 30 Days': [this.timezoneService.get()().subtract(29, 'days'), this.timezoneService.get()()],
    //   'This Month': [this.timezoneService.get()().startOf('month'), this.timezoneService.get()().endOf('month')],
    //   'Last Month': [this.timezoneService.get()().subtract(1, 'month').startOf('month'), this.timezoneService.get()().subtract(1, 'month').endOf('month')]
    // }
  };
  selectDateoption: any = "Today";
  prevSelectDateoption: any = "Yesterday";
  currentData: any = 0.0;
  prevData: any = 0.0;
  percentage: any = 0.0;
  dateFilteroptions = [
    "Today",
    "Yesterday",
    "This Week",
    "This Month",
    "This Quarter",
    "Custom",
    // "Last 7 days",
    // "Last month",
    // "Last 3 months",
    // "Last 12 months",
    // "Month to date",
    // "Quater to date",
    // "Year to date",
    // "All the time"
  ];
  public generateData(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  }
  ngOnInit() {
    // this.locService.currentApprovalStageMessage.subscribe(storeId => {
    //   if(storeId) {
    //     this.changeStore(storeId)
    //   }
    // });
    this.selected = [this.startDateDisplay, this.endDateDisplay];
    // this.store.select(getSelectedStoreLocation).subscribe((result) => {
    //   this.currency = result.currency;
    // });
    this.breadCrumbItems = [
      { label: "Charts" },
      { label: "Apex charts", active: true },
    ];

    // forkJoin([
    //   this.translatePipe.transform("Current"),
    //   this.translatePipe.transform("Previous"),
    // ]).subscribe(([textCurrent, textPrevious]) => {
    //   this.textCurrent = textCurrent;
    //   this.textPrevious = textPrevious
    // },
    // (error) => {
    //   console.error("Error in translating", error);
    // });


    /**
     * Fethches the chart data
     */
    this._fetchData();
  }

  /**
   * Fetches the chart data
   */
  private _fetchData() {
    // this.linewithDataChart = linewithDataChart;
    // this.basicColumChart = basicColumChart;
    // this.columnlabelChart = columnlabelChart;
    // this.lineColumAreaChart = lineColumAreaChart;
    // this.basicRadialBarChart = basicRadialBarChart;
    // this.simplePieChart = simplePieChart;
    // this.donutChart = donutChart;
    // this.barChart = barChart;
    // this.splineAreaChart = splineAreaChart;
    // this.dashedLineChart = dashedLineChart;
    const lineColumAreaChart: ChartType = {
      chart: {
        height: 350,
        type: "line",
        // dropShadow: {
        //   enabled: true,
        //   color: '#000000',
        //   top: 15,
        //   left: 7,
        //   blur: 15,
        //   opacity: 0.3,
        // },
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      // plotOptions: {
      //   bar: {
      //     columnWidth: '50%'
      //   }
      // },
      colors: ["#000000", "#cccccc"],
      series: [
        {
          name: this.textCurrent,
          type: "line",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: this.textPrevious,
          type: "line",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: "light",
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100],
        },
      },
      // tslint:disable-next-line: max-line-length
      labels: [
        "01-01-2003",
        "02-01-2003",
        "03-01-2003",
        "04-01-2003",
        "05-01-2003",
        "06-01-2003",
        "07-01-2003",
        "08-01-2003",
        "09-01-2003",
        "10-01-2003",
        "11-01-2003",
      ],
      markers: {
        size: 0,
      },
      // legend: {
      //   offsetY: 10,
      //   markers: {
      //     width: 7,
      //     height: 7
      //   },
      // },
      xaxis: {
        type: "dateTime",
        axisBorder: {
          show: true,
          color: "#d2d2d2",
          height: 1,
          width: "100%",
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#d2d2d2",
          height: 6,
          offsetX: 0,
          offsetY: 0,
        },
      },
      yaxis: {
        // title: {
        //     text: 'Points',
        // },
        labels: {
          formatter: function (value) {
            return "$ " + value;
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter(y) {
            if (typeof y !== "undefined") {
              return "$ " + y.toFixed(0);
            }
            return y;
          },
        },
      },
      grid: {
        borderColor: "#000000",
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              height: "auto",
              type: "line",
            },
          },
        },
      ],
    };
    //this.netSalesData = lineColumAreaChart
    this.getNetSaleReport();
  }
  changeStore(event: any) {
    this.storeIdFixed = event;
    this.getNetSaleReport();
  }
  onDateRangeChange(e) {
    console.log(this.selected);
  }
  async selectedDateOption(type) {
    console.log("I WAS TRIGGERED", type);
    this.selectDateoption = type;
    if (type === "This Month") {
      this.prevSelectDateoption = "Last Month";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "months").startOf("month");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("month");
      this.endDate = this.timezoneService.get()().endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    } else if (type === "Last Month") {
      this.prevSelectDateoption = "Month before last month";
      this.prevStartDate = this.timezoneService.get()().subtract(2, "months").startOf("month");
      this.prevEndDate = this.timezoneService.get()().subtract(2, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().subtract(1, "months").startOf("month");
      this.endDate = this.timezoneService.get()().subtract(1, "months").endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    }else if (type === "Yesterday"){
      this.prevSelectDateoption = "Day Before Yesterday";
      this.prevStartDate = this.timezoneService.get()().subtract(2, "days").startOf("day");
      this.prevEndDate = this.timezoneService.get()().subtract(2, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().subtract(1, "days").startOf("day");
      this.endDate = this.timezoneService.get()().subtract(1, "days").endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    }
     else if (type === "Today") {
      this.prevSelectDateoption = "Yesterday";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "days").startOf("day");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("day");
      this.endDate = this.timezoneService.get()().endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    } else if (type === "This Week") {
      this.prevSelectDateoption = "Last Week";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "week").startOf("week");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "week").endOf("week");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("week");
      this.endDate = this.timezoneService.get()().endOf("week");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    } else if (type === "This Quarter") {
      this.prevSelectDateoption = "Last Quarter";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "quarter").startOf("quarter");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "quarter").endOf("quarter");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().quarter(this.timezoneService.get()().quarter()).startOf("quarter");
      this.endDate = this.timezoneService.get()().quarter(this.timezoneService.get()().quarter()).endOf("quarter");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getNetSaleReport();
    } else if (type === "Last 3 months") {
      this.prevSelectDateoption = "3 months before last 3 months";
    } else if (type === "Last 12 months") {
      this.prevSelectDateoption = "12 months before last 12 months";
    } else if (type === "Month to date") {
    } else if (type === "Quater to date") {
    } else if (type === "Year to date") {
    } else if (type === "All the time") {
      this.prevSelectDateoption = "All the time";
    }
  }

  a1
  a2

  // async selectedDate(event: any) {
  //   // this.showItemCountPP = 0
  //   // this.p = 1;
  //   console.log("SELECTED DATEEE");
  //   let day = this.authService.getClosingDay();
  //   console.log("day", day);
  //   const value = {
  //     start: moment(this.a1),
  //     end: moment(this.a2)
  //   }

  //   this.startDate = value.start;
  //   this.endDate = value.end;

  //   var a = this.timezoneService.get()(this.endDate);
  //   var b = this.timezoneService.get()(this.startDate);
  //   var diff = a.diff(b, "days") + 1;

  //   console.log("diff", diff)
  //   // this.prevStartDate = this.timezoneService.get()(this.a1).add(1, "days").startOf("day");
  //   this.startDate = this.timezoneService.get()(this.a1).startOf("day");
  //   this.endDate = this.timezoneService.get()(this.a2).endOf("day");

  //   this.prevStartDate = this.timezoneService.get()(value.start).subtract(diff, "day").startOf("day");
  //   this.prevEndDate = this.timezoneService.get()(value.end).subtract(diff, "day").endOf("day");

  //   const nativeDate = new Date(this.a1);
  //   const nativeMonth = nativeDate.getMonth();
  //   const nativeDay = nativeDate.getDate();

  //   const startDateMonth = this.startDate.month();
  //   const startDateMonthDay = this.startDate.date();

  //   const equalMonth = startDateMonth === nativeMonth;
  //   const equalDay = startDateMonthDay === nativeDay;

  //   console.log("startDateMonth", startDateMonth, startDateMonthDay);
  //   console.log("nativeMonth", nativeMonth, nativeDay);

  //   if (!equalMonth || (equalMonth && !equalDay)) {
  //     console.log("IFFF")
  //     this.startDate = this.startDate.add(1, 'days');
  //     this.prevStartDate = this.prevStartDate.add(1, 'days');
  //     this.endDate = this.endDate.add(1, 'days');
  //     this.prevEndDate = this.prevEndDate.add(1, 'days');
  //   }

  //   // this.prevEndDate = this.timezoneService.get()(this.a2).add(1, "days").endOf("day");
  //   this.prevStartDateDisplay = this.prevStartDate.unix();
  //   console.log("this.prevStartDateDisplay", this.prevStartDateDisplay)
  //   this.prevEndDateDisplay = this.prevEndDate.unix();
  //   console.log("this.prevEndDateDisplay", this.prevEndDateDisplay)
  //   this.prevStartDateDisplayFormatted = this.timezoneService.get()
  //     .unix(this.prevStartDateDisplay)
  //     .format("MMM D YYYY");
  //   this.prevEndDateDisplayFormatted = this.timezoneService.get()
  //     .unix(this.prevEndDateDisplay)
  //     .format("MMM D YYYY");
  //   this.prevSelectDateoption =
  //     this.prevStartDateDisplayFormatted +
  //     " to " +
  //     this.prevEndDateDisplayFormatted;

  //     // this.startDate = this.timezoneService.get()(this.a1).add(1, "days").startOf("day");
  //   if (day === 'Same Day') {
  //     // this.startDate = this.startDate.add(1, 'days');
  //     // this.endDate = this.endDate.add(1, 'days');
  //   }
  //   this.startDateDisplay = this.startDate.unix();
  //   this.endDateDisplay = this.endDate.unix();
  //   this.startDateDisplayFormatted = this.timezoneService.get()
  //     .unix(this.startDateDisplay)
  //     .format("MMM D YYYY");
  //   this.endDateDisplayFormatted = this.timezoneService.get()
  //     .unix(this.endDateDisplay)
  //     .format("MMM D YYYY");
  //   this.selectDateoption = "custom";
  //   this.customDate =
  //     this.startDateDisplayFormatted + " to " + this.endDateDisplayFormatted;

  //   if (this.prevEndDateDisplayFormatted == "Invalid date") {
  //     return;
  //   }
  //   await this.getNetSaleReport();
  // }
  async selectedDate(event: any) {
    console.log("SELECTED DATE");

    // Store references to the date picker values
    const value = {
        start: moment(this.a1),
        end: moment(this.a2)
    };

    // Set start and end dates for the current selection
    this.startDate = this.timezoneService.get()(value.start).startOf("day");
    this.endDate = this.timezoneService.get()(value.end).endOf("day");

    // Calculate the difference in days to set the previous date range
    const diff = this.endDate.diff(this.startDate, "days") + 1;
    this.prevStartDate = this.startDate.clone().subtract(diff, "days");
    this.prevEndDate = this.endDate.clone().subtract(diff, "days");

    // Adjust the start and end dates if needed based on your business logic
    const nativeDate = new Date(this.a1);
    if (this.startDate.month() !== nativeDate.getMonth() || this.startDate.date() !== nativeDate.getDate()) {
        console.log("Adjusting Dates");
        this.startDate.add(1, 'days');
        this.endDate.add(1, 'days');
        this.prevStartDate.add(1, 'days');
        this.prevEndDate.add(1, 'days');
    }

    // Set display values for both current and previous date ranges
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.prevStartDateDisplay = this.prevStartDate.unix();
    this.prevEndDateDisplay = this.prevEndDate.unix();

    this.startDateDisplayFormatted = this.startDate.format("MMM D YYYY");
    this.endDateDisplayFormatted = this.endDate.format("MMM D YYYY");
    this.prevStartDateDisplayFormatted = this.prevStartDate.format("MMM D YYYY");
    this.prevEndDateDisplayFormatted = this.prevEndDate.format("MMM D YYYY");

    this.prevSelectDateoption = `${this.prevStartDateDisplayFormatted} to ${this.prevEndDateDisplayFormatted}`;
    this.selectDateoption = "custom";
    this.customDate = `${this.startDateDisplayFormatted} to ${this.endDateDisplayFormatted}`;

    // Check for invalid dates and fetch the report
    if (this.prevEndDateDisplayFormatted !== "Invalid date") {
        await this.getNetSaleReport();
    }
}
  customDate: any = "";

  loader: Boolean = false;
  netSalesData: ChartType;
  async getNetSaleReport() {
    console.log("this.selectDateoption", this.selectDateoption)
    // Subtract 1 day from end date if this.selectDateoption is custom
    // if (this.selectDateoption === "custom") {
    //   this.customEndDate = this.timezoneService.get()(this.endDate).subtract(1, "day").endOf("day");
    //   this.endDateDisplay = this.customEndDate.unix();
    // }
    let params = {
      reportName: "home_report",
      query: {
        metric: "netSales",
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
      },
    };
    this.loader = true;
    return this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .pipe(shareReplay(1))
      .subscribe(
        (response: any) => {
          this.getNetsale();
          if (response) {
            this.currentData = response.total;
            this.prevData = response.lastTotal;
            this.percentage = response.percentage;
            let dates = [];
            let currentDates = [];
            let lastDates = [];
            let currentData = [];
            let prevData = [];
            let cIntervalCounter = 1
            let pIntervalCounter = 1
            var push = false

            // console.log("netSales", response)
            if (response.lastIntervals) {
              response.lastIntervals.forEach((element) => {
                var date = element.key;
                if (this.startDate.diff(this.endDate, "days") === 0) {
                  push = true
                  // console.log("element.key", element.key)
                  date = this.timezoneService.get()(element.key).format("hh:mm A");
                } else {
                  // console.log("element.key_as_string", element.key_as_string);
                  // Parse the date string correctly
                  const parsedDate = this.timezoneService.get()(element.key_as_string, "MM-DD-YYYY");
                  date = parsedDate.format("MMM DD");
                }

                //if (push === true || pIntervalCounter < response.lastIntervals.length) {
                lastDates.push(date);
                prevData.push(element.netSales);
                //}
                pIntervalCounter++
              });
            }

            if (response.intervals) {
              response.intervals.forEach((element) => {
                var date = element.key;
                if (this.startDate.diff(this.endDate, "days") === 0) {
                  push = true
                  date = this.timezoneService.get()(element.key).format("hh:mm A");
                } else {
                  // Parse the date string correctly
                  const parsedDate = this.timezoneService.get()(element.key_as_string, "MM-DD-YYYY");
                  date = parsedDate.format("MMM DD");
                }

                //if (push === true || cIntervalCounter < response.intervals.length) {
                currentDates.push(date);
                currentData.push(element.netSales);
                //}

                cIntervalCounter++
              });
            }

            for (let i = 0; i < currentDates.length; i++) {
              let stringDate = ''
              if (push)
                stringDate = currentDates[i]
              else
                stringDate = currentDates[i] + " - " + lastDates[i]
              dates.push(stringDate);
            }

            // response.lastIntervals.forEach(element => {
            //   prevData.push(element.netSales)
            // });
            // console.log("THIS>CURRENCY_TY", typeof this.currency, this.currency)
            // if this.currency is undefined or null, set it to $ by default else use the value to this.currency
            let graphCurrency: string;
            if (this.currency == undefined || this.currency == null) {
              graphCurrency = "$";
            } else {
              graphCurrency = this.currency;
            }

            const lineColumAreaChart: ChartType = {
              chart: {
                height: 350,
                type: "line",
                // dropShadow: {
                //   enabled: true,
                //   color: '#000000',
                //   top: 15,
                //   left: 7,
                //   blur: 10,
                //   opacity: 0.4,
                // },
                stacked: false,
                toolbar: {
                  show: false,
                },
              },
              stroke: {
                width: 3,
                curve: "smooth",
              },
              // plotOptions: {
              //   bar: {
              //     columnWidth: '100%'
              //   }
              // },
              colors: ["#000000", "#cccccc"],
              series: [
                {
                  name: this.textCurrent,
                  type: "line",
                  data: currentData,
                },
                {
                  name: this.textPrevious,
                  type: "line",
                  data: prevData,
                },
              ],
              fill: {
                opacity: [1, 1],
                gradient: {
                  inverseColors: true,
                  shade: "light",
                  type: "vertical",
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100, 100, 100],
                },
              },
              // tslint:disable-next-line: max-line-length
              labels: dates,
              markers: {
                size: 0,
              },
              // legend: {
              //   offsetY: 10,
              //   markers: {
              //     width: 7,
              //     height: 7
              //   },
              // },
              xaxis: {
                type: "dateTime",
                axisBorder: {
                  show: true,
                  color: "#d2d2d2",
                  height: 1,
                  width: "100%",
                  offsetX: 0,
                  offsetY: 0,
                },
                axisTicks: {
                  show: true,
                  borderType: "solid",
                  color: "#d2d2d2",
                  height: 6,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
              yaxis: {
                // title: {
                //     text: 'Points',
                // },
                labels: {
                  formatter: function (value) {
                    // return "$ " + parseInt(value);
                    return graphCurrency + ' ' + parseInt(value);
                  },
                },
              },
              tooltip: {
                shared: true,
                intersect: false,
                y: {
                  formatter(y) {
                    if (typeof y !== "undefined") {
                      // return "$ " + y.toLocaleString("en-US");
                      return graphCurrency + ' ' + y.toLocaleString("en-US");
                    }
                    return y;
                  },
                },
              },
              grid: {
                borderColor: "#000000",
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      height: "auto",
                      type: "line",
                    },
                  },
                },
              ],
            };
            window.dispatchEvent(new Event('resize'));
            this.netSalesData = lineColumAreaChart;
            this.loader = false;
          } else {
            //this.toastr.error(response.message);
            this.loader = false;
          }
        },
        (error) => {
          this.netSalesData = lineColumAreaChart;
          this.loader = false;
          //this.toastr.success(error.message, { autoClose: false });
          //jQuery(".allpageLoader").css("display","none");
        }
      );
  }
  getNetsale() {
    let params = {
      reportName: "home_stats_report",
      query: {
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.prevStartDateDisplay,
        lastEndDate: this.prevEndDateDisplay,
        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
      },
    };
    return this.http
    .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
    .pipe(shareReplay(1))
    .subscribe((response: any) => {
      if (!response.error) {
        this.cardData = response.data
      } else {
        //this.toastr.error(response.message)
      }
    }, (error) => {
    });
  }
  checkNegative(num: any) {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  }
  checkZeroInc(num: any) {
    if (Math.abs(num) === 0) {
      return true
    }
    return false
  }
  showPlusData(num) {
    return "+" + num;
  }

  navigateAndClose(route: string) {
    // Navigate to the specified route
    this.router.navigate([route]);
  }

}
